const DoctorDashboard = () => {
    return (
        <>
            <div>
                <br/>
                <br/>
                <br/>
                <h3>dashboard page DOCTOR</h3>
            </div>
        </>
    )
}

export default DoctorDashboard;